__turbopack_context__.v({
  "collapseContent": "material-editor-module__ehuvXW__collapseContent",
  "colorPickerContainer": "material-editor-module__ehuvXW__colorPickerContainer",
  "container": "material-editor-module__ehuvXW__container",
  "radioGroup": "material-editor-module__ehuvXW__radioGroup",
  "section": "material-editor-module__ehuvXW__section",
  "sliderContainer": "material-editor-module__ehuvXW__sliderContainer",
  "textureGrid": "material-editor-module__ehuvXW__textureGrid",
  "textureItem": "material-editor-module__ehuvXW__textureItem",
});
